import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Button from "../../../../components/Button/Button";
import Card from "../../../../components/Card/Card";
import DeleteButton from "../../../../components/DeleteButton/DeleteButton";
import Input from "../../../../components/Input/Input";
import List from "../../../../components/List/List";
import ModalComponent from "../../../../components/Modal/ModalComponent";
import Select from "../../../../components/Select/Select";
import { useListManager } from "../../../../contexts/list.manager";
import CredentialsService from "../../../../services/CredentialsService";
import "../TabsCondoUsers.css";
import "./TabCondoUsersCredentials.css";
import { v4 as uuidv4 } from 'uuid';
import Checkbox from "../../../../components/Checkbox/Checkbox";
import ToolTip from "../../../../components/Tooltip/Tooltip";
import { CREDENTIAL_TYPE_CODES, CREDENTIAL_TYPE_NAMES } from "../../../../constants/credentials";
import { useSSEContext } from "../../../../contexts/sse";
import { MdEdit } from "react-icons/md";
import { joinWithCommaAnd } from "../../../../utils/string";
import { BiScan } from "react-icons/bi";
import { useTranslation } from "react-i18next";

const TabCondoUserCredentials = (props) => {
	const [condoUserCredentials, setCondoUserCredentials] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [showDetectModal, setShowDetectModal] = useState(false);
	const [id, setId] = useState(null);
	const [type, setType] = useState(null);
	const [code, setCode] = useState("");
	const [detectType, setDetectType] = useState("");
	const [mode, setMode] = useState("");
	const [licenses, setLicenses] = useState([]);
	const [isDetecting, setIsDetecting] = useState(false);
	const { lineSelected, closeForm } = useListManager();
	const { sseReceived } = useSSEContext();
	const { t } = useTranslation();

	const getCondoUserCredentials = async (condoUser) => {
		if (!condoUser?.id) return;
		const response = await CredentialsService.listCredentialsByCondoUser(
			condoUser?.id,
		);
		setCondoUserCredentials(response.data);
	};

	useEffect(() => {
		setCondoUserCredentials(props.credentials?.map(credential => ({
			...credential,
			_id: credential.id ?? credential.uuid,
			licenses: credential.licenses ?? credential.licenseIds?.map(id => ({ id })) ?? [],
		})) ?? []);
	}, [props.credentials]);


	useEffect(() => {
		if (!isDetecting || !sseReceived) return;
		const event = sseReceived.content;
		if (!event?.info) return;
		const eventCredentialTypes = CREDENTIAL_TYPE_CODES?.[event.info.trim()];
		console.log(event, eventCredentialTypes, detectType);
		if (
			eventCredentialTypes &&
			event.name_code === 9 &&
			event.result === 'Falha' &&
			eventCredentialTypes.includes(Number(detectType))
		) {
			setIsDetecting(false);
			setShowDetectModal(false);
			setCode(event.data);
			setType(detectType);
			setMode("add");
			setShowModal(true);
			setDetectType("");
		}
	}, [sseReceived]);

	function validateCredential(payload) {
		if (!payload.type) {
			NotificationManager.warning(
				"Tipo é obrigatório",
				"Atenção!",
			);
			return false;
		}
		if (!payload.code) {
			NotificationManager.warning(
				"Código é obrigatório",
				"Atenção!",
			);
			return false;
		}
		if ([2, 3].includes(payload.type)) {
			if (!/^[0-9]+$/.test(payload.code)) {
				NotificationManager.warning(
					"Senhas devem conter apenas números",
					"Atenção!",
				);
				return false;
			}
		}
		return true;
	}

	async function saveNewCredentials() {
		let payload = {
			_id: uuidv4(),
			type: parseInt(type),
			code: code,
			licenses,
		};
		if (!validateCredential(payload)) return;
		// setCondoUserCredentials((prevCredentials) => [...prevCredentials, payload]);
		const newCondoUserCredentials = [...condoUserCredentials, payload];
		props.handleChangeCredentials(newCondoUserCredentials);
	}

	async function editCredentials() {
		const indexToUpdate = condoUserCredentials.findIndex(
			(i) => i._id === id,
		);
		if (indexToUpdate !== -1) {
			const updatedPayload = {
				...condoUserCredentials[indexToUpdate],
				type: parseInt(type),
				code: code,
				condoUser: props.condoUser,
				licenses,
			};
			if (!validateCredential(updatedPayload)) return;
			const updatedCondoUserCredentials = condoUserCredentials.map(
				(item, index) => {
					if (index === indexToUpdate) {
						return updatedPayload;
					}
					return item;
				},
			);
			// setCondoUserCredentials(updatedCondoUserCredentials);
			props.handleChangeCredentials(updatedCondoUserCredentials);
		}
	}

	async function removeCredentials(item) {
		const indexToRemove = condoUserCredentials.findIndex(
			(i) => i._id === item._id,
		);
		if (indexToRemove !== -1) {
			const updatedCondoUserCredentials = [
				...condoUserCredentials.slice(0, indexToRemove),
				...condoUserCredentials.slice(indexToRemove + 1),
			];
			// setCondoUserCredentials(updatedCondoUserCredentials);
			props.handleChangeCredentials(updatedCondoUserCredentials);
			closeForm();
		}
	}

	const handleClickModalButton = (action) => {
		if (action === "confirm") {
			if (mode === "add") saveNewCredentials();
			if (mode === "edit") editCredentials();
		}
		setType("");
		setCode("");
		setId(null);
		setLicenses([]);
		setShowModal(false);
		closeForm();
	};

	const handleClickAdd = () => {
		setMode("add");
		setShowModal(true);
	};

	const handleClickEdit = (row) => {
		const item = row ?? lineSelected;
		if (!item) return;
		setMode("edit");
		setType(item.type);
		setCode(item.code);
		setId(item._id);
		setLicenses(item.licenses);
		setShowModal(true);
	};

	const handleClickRemove = (row) => {
		const item = row ?? lineSelected;
		if (!item) return;
		removeCredentials(item);
	};

	// Lógica para detecção com loading
	const handleDetect = () => {
		if (!detectType) {
			NotificationManager.warning(
				"Selecione um tipo de credencial para detecção",
				"Atenção!",
			);
			return;
		}
		// Inicia o loading e simula a detecção
		setIsDetecting(true);
		// Simulação de espera (por exemplo, 2 segundos)
		setTimeout(() => {
			setIsDetecting(false);
			setShowDetectModal(false);
			setDetectType("");
		}, 20000000);
	};

	function renderInputCode() {
		let inputType = "text";
		if ([2, 3].includes(type)) {
			inputType = "password";
		}

		return (
			<Input
				name="code"
				id="code"
				type={inputType}
				labelText={"Código"}
				value={code}
				onChange={({ target }) => setCode(target.value)}
				tooltipText="Insira o código da credencial"
				tooltipVisible={true}
				showablePassword={false}
			/>
		);
	}

	return (
		<div
			style={{ display: "flex", alignItems: "center", flexDirection: "column" }}
		>
			<div className="tab-condo-users-buttons-container">
				<div className="tab-condo-users-buttons">
					<Button
						action="add"
						className="tab-condo-users-add button-white w-[200px]!"
						label="Adicionar Credencial"
						onClick={handleClickAdd}
					/>
				</div>
				<Button
					icon={<BiScan size={18} />}
					className="button-white w-[120px]!"
					label="Detectar"
					onClick={() => setShowDetectModal(true)}
				/>
			</div>
			<div className="list-visibility w-full">
				<List
					selectable={false}
					collumsObjIndex={[
						{ collumnLabel: "Tipo", index: "type", type: "changeValue" },
						{ collumnLabel: "Código", index: "code", custom: ({ row }) => [2, 3].includes(row.type) ? row.code.replace(/./g, '*') : row.code },
						{
							collumnLabel: "Licenças", index: "licenses", custom: ({ row }) => {
								return joinWithCommaAnd(row.licenses?.map(l => {
									return props.condoUserLicenses?.find(l2 => l2.license.id === l.id)?.ownerUnit?.name;
								})?.filter(n => n))
							}
						},
						{
							collumnLabel: "Ações", type: "actions", custom: ({ row }) => {
								return (
									<div className="flex justify-end gap-4">
										<button type="button" className={`cursor-pointer hover:opacity-70 duration-100`} onClick={e => {
											handleClickEdit(row);
										}}>
											<MdEdit size={18} />
										</button>
										<DeleteButton
											className="button-white tab-condo-users-buttons-visibility"
											handleDelete={() => handleClickRemove(row)}
											simple
										/>
									</div>
								);
							}
						},
					]}
					changeColumnValue={[
						{ old: 1, new: "Controle Remoto" },
						{ old: 2, new: "Senha" },
						{ old: 3, new: "Senha Pânico" },
						{ old: 4, new: "Tag" },
						{ old: 5, new: "ID CtrlId" },
						{ old: 6, new: "Credencial Remota" },
						{ old: 7, new: "Tag Sem Parar" },
					]}
					data={condoUserCredentials}
				/>
			</div>
			<div
				className="card-visibility"
				style={{ width: "100%", maxWidth: "500px" }}
			>
				{condoUserCredentials?.length > 0 ? (
					condoUserCredentials.map((credential, index) => (
						<Card
							key={index}
							data={credential}
							delete={() => handleClickRemove(credential)}
							edit={() => handleClickEdit(credential)}
						>
							<p className="card-content-title">{credential.type}</p>
							<p className="card-content">Código: {credential.code}</p>
						</Card>
					))
				) : (
					<div
						style={{
							marginTop: "10px",
							backgroundColor: "var(--textColor)",
							padding: "10px",
							textAlign: "center",
						}}
					>
						Nenhum registro encontrado.
					</div>
				)}
			</div>
			<ModalComponent
				modalIsOpen={showModal}
				handleConfirm={() => handleClickModalButton("confirm")}
				handleCancel={() => handleClickModalButton("cancel")}
				modalText={"Adicionar credencial"}
				buttonLabel1={"Confirmar"}
			>
				<div className="modal-credentials">
					<Select
						labelText="Tipo"
						name="type"
						id="type"
						value={type}
						onChange={({ target }) => {
							setType(Number(target.value));
							setCode("");
						}}
						options={[
							{ value: 1, text: "Controle Remoto" },
							{ value: 2, text: "Senha" },
							{ value: 3, text: "Senha Pânico" },
							{ value: 4, text: "Tag" },
							{ value: 5, text: "ID CtrlId" },
							{ value: 6, text: "Credencial Remota" },
							{ value: 7, text: "Tag Sem Parar" },
						]}
						tooltipText="Selecione o tipo de credencial"
						tooltipVisible={true}
					/>
					{renderInputCode()}
					<div className="w-full">
						<p style={{ display: 'flex', gap: '5px', fontSize: '14px', textAlign: 'left', color: 'var(--textColor)', marginBottom: 5 }}>
							<span>Licenças</span>
							<ToolTip
								tooltipVisible={true}
								tooltipText={"Selecione as licenças para as quais esta credencial deve ser enviada."}
							/>
						</p>
						{props.condoUserLicenses?.length > 0 ? (
							<div className="flex justify-start gap-4">
								{props.condoUserLicenses.map(l => (
									<Checkbox
										name={`licenses${l.id}`}
										style={{ width: "fit-content" }}
										labelText={l.ownerUnit.name}
										checked={licenses.some(l2 => l2.id === l.license.id)}
										onChange={({ target }) => {
											setLicenses(prevLicenses => {
												let _licenses = [...prevLicenses];
												if (target.checked) {
													if (!_licenses.find(pl => pl.id === l.license.id)) {
														_licenses.push({ id: l.license.id });
													}
												} else {
													_licenses = _licenses.filter(pl => pl.id !== l.license.id);
												}
												return _licenses;
											});
										}}
										required={false}
									/>
								))}
							</div>
						) : (
							<p className="text-sm! text-left text-(--textColor) mb-1! opacity-40">
								Nenhuma licença vinculada para este usuário
							</p>
						)}
					</div>
				</div>
			</ModalComponent>

			{/* Modal de detecção */}
			<ModalComponent
				modalIsOpen={showDetectModal}
				handleConfirm={handleDetect}
				handleCancel={() => {
					setShowDetectModal(false);
					setIsDetecting(false);
					setDetectType("");
				}}
				modalText={isDetecting ? `Detectando ${CREDENTIAL_TYPE_NAMES[detectType]}...` : "Selecione o tipo para detecção"}
				disableConfirm={isDetecting}
				buttonLabel1={"Detectar"}
			>
				{isDetecting ? (
					<div className="detect-loading">
						<div className="spinner" />
					</div>
				) : (
					<Select
						labelText="Tipo"
						name="detectType"
						id="detectType"
						value={detectType}
						onChange={({ target }) => setDetectType(target.value)}
						options={[
							{ value: 1, text: t(CREDENTIAL_TYPE_NAMES[1]) },
							{ value: 2, text: t(CREDENTIAL_TYPE_NAMES[2]) },
							{ value: 3, text: t(CREDENTIAL_TYPE_NAMES[3]) },
							{ value: 4, text: t(CREDENTIAL_TYPE_NAMES[4]) },
							{ value: 5, text: t(CREDENTIAL_TYPE_NAMES[5]) },
							{ value: 6, text: t(CREDENTIAL_TYPE_NAMES[6]) },
							{ value: 7, text: t(CREDENTIAL_TYPE_NAMES[7]) },
						]}
						tooltipText="Selecione o tipo de credencial para detecção"
						tooltipVisible={true}
					/>
				)}
			</ModalComponent>
		</div>
	);
};

export default TabCondoUserCredentials;
